import { ProjectResponse } from "../../../types/project";
import { normalizeApiError } from "../../../utils/normalizeApiError";
import axiosInstance from "../../axiosInstance";

export const getProjectsSummary = async (appUserUuid?: string): Promise<ProjectResponse> => {
  try {
    const { data } = await axiosInstance.get<any>(
      `/pmo/get-projects-summary`,
      { params: appUserUuid ? { appUserUuid } : undefined }
    );

    // Support both old array response and new standard paginated response
    if (data?.response && !Array.isArray(data.response) && data.response.data) {
      return data.response as ProjectResponse;
    }
  
    // Check if response is directly an array of projects
    if (Array.isArray(data?.response)) {
      // If the first item has projectUuid, the array itself is the list of projects
      if (data.response.length === 0 || data.response[0].projectUuid) {
        return {
          status: true,
          message: "Success",
          data: data.response,
          totalPages: 1,
          totalElements: data.response.length,
          currentPage: 0,
          pageSize: data.response.length || 100,
        };
      }
      // Otherwise, it might be the old wrapped response format
      if (data.response[0]) {
        return data.response[0] as ProjectResponse;
      }
    }

    // Fallback
    const projects = data?.data ?? [];
    return {
      status: true,
      message: "Success",
      data: projects,
      totalPages: 1,
      totalElements: projects.length,
      currentPage: 0,
      pageSize: projects.length || 100,
    };
  } catch (error) {
    throw normalizeApiError(error);
  }
};
